<div class="grid">
  <div class="col-12 col-12 md:col-12">
    <p-panel header="{{ titulo }}">
      <app-flujo-venta-tab-view
        [tabView]="tabView"
        [listaSecuencias]="listaSecuencias"
        [listaVinculaciones]="listaVinculaciones"
        [lisPasos]="lisPasos"
        [secFija]="true"
        [showControlesTable]="false">
      </app-flujo-venta-tab-view>
    </p-panel>
  </div>
</div>
